const FormatService = {

  currency(amount) {
    return Number(amount).toFixed(2)
  },


  formatPlooi(value) {
    switch (value) {
      case 'enkel': return 'Enkel';
      case 'dubbel': return 'Dubbel';
      case 'wave': return 'Wave';
      case 'enkel-retour': return 'Enkel retour';
      case 'dubbel-retour': return 'Dubbel retour';
      default: 
    }
    return '';
  },

  formatDuettes(value) {
    switch (value) {
      case 'lichtdoorlatend': return 'Lichtdoorlatend';
      case 'verduisterend': return 'Verduisterend';
      default:
    }
    return '';
  },

  formatDuettesOptions(value) {
    switch (value) {
      case 'bb24': return 'BB24';
      case 'bb24+gpp': return 'BB24 +GPP';
      case 'ao20': return 'AO20';
      case 'al20': return 'AL20';
      default:
    }
    return '';
  },

  formatHorizontalBlinds(value) {
    switch (value) {
      case 'bamboe': return 'Bamboe';
      case 'aluminium': return 'Aluminium';
      default:
    }
    return '';
  },

  formatBand(value) {
    switch (value) {
      case 'ladderkoord': return 'Ladderkoord';
      case 'breedband': return 'Breedband';
      default:
    }
    return '';
  },

  formatRollcurtains(value) {
    switch (value) {
      case 'transparant': return 'Transparant';
      case 'lichtdoorlatend': return 'Lichtdoorlatend';
      case 'verduisterend': return 'Verduisterend';
      default:
    }
    return '';
  }

}


export default FormatService